<template>
  <section
    v-if="items.length"
    class="border-b border-default/40 bg-elevated/30"
  >
    <UContainer class="py-8 sm:py-10">
      <h2
        v-if="title"
        class="mb-6 text-center text-2xl font-bold text-highlighted sm:text-3xl"
      >
        {{ title }}
      </h2>
      <div
        class="grid gap-3"
        :class="gridClass"
      >
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex h-full flex-col items-center gap-2 rounded-xl border border-default/50 bg-default/60 p-4 text-center shadow-sm"
        >
          <div class="flex size-11 items-center justify-center rounded-full bg-primary/10 text-primary">
            <UIcon :name="item.icon || 'i-heroicons-check'" class="size-5" />
          </div>
          <span class="text-sm font-medium text-highlighted">
            {{ item.label }}
          </span>
        </div>
      </div>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
export type HighlightItem = {
  icon?: string
  label?: string
}

const props = withDefaults(
  defineProps<{
    title?: string
    items?: HighlightItem[]
  }>(),
  {
    items: () => [],
  },
)

const gridClass = computed(() => {
  const n = props.items.length
  if (n <= 2) return 'sm:grid-cols-2'
  if (n <= 3) return 'sm:grid-cols-3'
  if (n <= 4) return 'sm:grid-cols-2 lg:grid-cols-4'
  return 'sm:grid-cols-2 lg:grid-cols-5'
})
</script>
